import { Injectable, NgZone } from '@angular/core';
import { debounceTime, fromEvent, merge, Subject, Subscription, switchMap, tap, timer } from 'rxjs';
import { AccessHandler } from '../handlers/access-handler';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class IdleService {
  private timeoutDuration = environment.inactive_session_in_seconds * 1000; // inactivity time in milliseconds
  // private warningDuration = 60 * 1000; // 1 min before logout
  private warningDuration = environment.session_timeout_warning_in_seconds * 1000; //  warning time in milliseconds to show before logout
  private directLogoutTime = environment.session_logout_early_in_seconds * 1000; //  direct logout

  private timeoutSub?: Subscription;

  onTimeoutWarning$ = new Subject<string>();
  onAutoLogout$ = new Subject<string>();
  private timeoutRef!: any;

  // private activityEvents$ = merge(
  //   fromEvent(document, 'mousemove'),
  //   fromEvent(document, 'keydown'),
  //   fromEvent(document, 'scroll'),
  //   fromEvent(document, 'click'),
  //   fromEvent(window, 'touchstart')
  // );
  // private activitySubscription?: Subscription;

  constructor(private ngZone: NgZone, private accesshandler: AccessHandler) {}

  startWatching() {
    clearTimeout(this.timeoutRef);
    this.timeoutSub?.unsubscribe();
    const tokenExpireDate = this.accesshandler.getExpiration('mondelez_user');
    const timeLeftToInvoke = tokenExpireDate.diff(Date.now()) | 0;

    // this.ngZone.runOutsideAngular(() => {
    //   this.activitySubscription = this.activityEvents$.pipe(debounceTime(200)).subscribe(() => this.resetTimer());
    // });

    // ###invoke timeout popup  only when remaining time is more then visible counter i.e before 2 minute
    if (timeLeftToInvoke >= this.warningDuration) {
      this.timeoutRef = setTimeout(() => {
        this.timeoutSub?.unsubscribe();
        this.onTimeoutWarning$.next('SESSION_EXPIRE');
      }, timeLeftToInvoke - this.warningDuration);
      console.log('session warning apear time:', (timeLeftToInvoke - this.warningDuration) / 1000, ' seconds');
    } else if (timeLeftToInvoke < this.directLogoutTime) {
      this.timeoutSub?.unsubscribe();
      this.onAutoLogout$.next('REDIRECT_LOGIN');
    } else {
      console.log('Auto logout triggered time', timeLeftToInvoke / 1000, ' seconds');
      this.timeoutRef = setTimeout(() => {
        this.timeoutSub?.unsubscribe();
        this.onAutoLogout$.next('REDIRECT_LOGIN');
      }, timeLeftToInvoke - this.directLogoutTime);
    }

    // this.resetTimer();
  }

  // private resetTimer() {
  //   this.timeoutSub?.unsubscribe();

  //   this.timeoutSub = timer(this.timeoutDuration)
  //     .pipe(
  //       tap(() => this.ngZone.run(() => this.onTimeoutWarning$.next('INACTIVE'))),
  //       switchMap(() => timer(this.warningDuration))
  //     )
  //     .subscribe(() => {
  //       this.ngZone.run(() => this.onAutoLogout$.next(null));
  //     });
  // }

  stopWatching() {
    // this.activitySubscription?.unsubscribe();
    clearTimeout(this.timeoutRef);
    this.timeoutSub?.unsubscribe();
  }
}
